import { studentApi } from "./api";

const TOKEN_KEY = "pm_student_token";
const ACCOUNT_KEY = "pm_student_account";

const studentAuthService = {
  signup: (payload) => studentApi.post("/student-auth/signup", payload).then((r) => r.data),
  verifyOtp: (payload) => studentApi.post("/student-auth/verify-otp", payload).then((r) => r.data),
  resendOtp: (payload) => studentApi.post("/student-auth/resend-otp", payload).then((r) => r.data),
  login: (payload) => studentApi.post("/student-auth/login", payload).then((r) => r.data),
  forgotPassword: (payload) => studentApi.post("/student-auth/forgot-password", payload).then((r) => r.data),
  me: () => studentApi.get("/student-auth/me").then((r) => r.data),

  saveSession: ({ token, account }) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(ACCOUNT_KEY, JSON.stringify(account));
  },
  getToken: () => localStorage.getItem(TOKEN_KEY),
  getAccount: () => {
    try {
      return JSON.parse(localStorage.getItem(ACCOUNT_KEY) || "null");
    } catch {
      return null;
    }
  },
  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(ACCOUNT_KEY);
  },
};

export default studentAuthService;
